export default {
  INCOMING_CALL: 'Incoming call',
};
